import React, { useId } from "react";

export default function ApplicantCoachAvatar({
  size = 88,
  className = "",
  title = "KI/AI Coach",
}) {
  const dimension = Number(size) || 88;
  const token = useId().replace(/:/g, "");
  const shellId = `coachAvatarShell-${token}`;
  const haloId = `coachAvatarHalo-${token}`;
  const faceId = `coachAvatarFace-${token}`;
  const glowId = `coachAvatarGlow-${token}`;
  const shadowId = `coachAvatarShadow-${token}`;

  return (
    <div
      className={`applicant-coach-avatar ${className}`.trim()}
      style={{ width: dimension, height: dimension }}
      aria-hidden="true"
    >
      <svg
        viewBox="0 0 128 128"
        width={dimension}
        height={dimension}
        role="img"
        aria-label={title}
      >
        <defs>
          <linearGradient id={shellId} x1="18" y1="12" x2="110" y2="116" gradientUnits="userSpaceOnUse">
            <stop offset="0" stopColor="#f9fcff" />
            <stop offset="0.34" stopColor="#d9e9f6" />
            <stop offset="0.72" stopColor="#8fb5d2" />
            <stop offset="1" stopColor="#6e879d" />
          </linearGradient>
          <linearGradient id={haloId} x1="22" y1="22" x2="106" y2="102" gradientUnits="userSpaceOnUse">
            <stop offset="0" stopColor="#7aa8c9" stopOpacity="0.76" />
            <stop offset="0.54" stopColor="#6dd1c1" stopOpacity="0.54" />
            <stop offset="1" stopColor="#6f8aa9" stopOpacity="0.52" />
          </linearGradient>
          <linearGradient id={faceId} x1="44" y1="34" x2="86" y2="94" gradientUnits="userSpaceOnUse">
            <stop offset="0" stopColor="#153552" />
            <stop offset="1" stopColor="#204563" />
          </linearGradient>
          <radialGradient id={glowId} cx="0" cy="0" r="1" gradientTransform="translate(34 28) rotate(41.6) scale(76.8)" gradientUnits="userSpaceOnUse">
            <stop offset="0" stopColor="#ffffff" stopOpacity="0.88" />
            <stop offset="0.48" stopColor="#b8ddf4" stopOpacity="0.38" />
            <stop offset="1" stopColor="#ffffff" stopOpacity="0" />
          </radialGradient>
          <filter id={shadowId} x="-20%" y="-20%" width="140%" height="140%">
            <feDropShadow dx="0" dy="14" stdDeviation="14" floodColor="#3b5874" floodOpacity="0.18" />
            <feDropShadow dx="0" dy="8" stdDeviation="10" floodColor="#7ca8c4" floodOpacity="0.12" />
          </filter>
        </defs>

        <g filter={`url(#${shadowId})`}>
          <circle cx="64" cy="64" r="58" fill={`url(#${haloId})`} opacity="0.24" />
          <circle cx="64" cy="64" r="52" fill={`url(#${shellId})`} />
          <circle cx="64" cy="64" r="50" fill={`url(#${glowId})`} opacity="0.82" />

          <circle cx="64" cy="50" r="22" fill={`url(#${faceId})`} />
          <path
            d="M39 96c2-19 13-28 25-28s23 9 25 28"
            fill="none"
            stroke={`url(#${faceId})`}
            strokeWidth="14"
            strokeLinecap="round"
          />

          <path
            d="M44 44c7-7 15-11 20-11s13 4 20 11"
            fill="none"
            stroke="rgba(255,255,255,0.56)"
            strokeWidth="3.8"
            strokeLinecap="round"
          />
          <path d="M51 53h8" fill="none" stroke="#dff2ff" strokeWidth="3.4" strokeLinecap="round" />
          <path d="M69 53h8" fill="none" stroke="#dff2ff" strokeWidth="3.4" strokeLinecap="round" />
          <path
            d="M55 63c2.6 2.6 5.7 4 9 4s6.4-1.4 9-4"
            fill="none"
            stroke="#bfe5ff"
            strokeWidth="3.2"
            strokeLinecap="round"
          />

          <path d="M22 67c6-2 10-7 12-14" fill="none" stroke="rgba(255,255,255,0.55)" strokeWidth="2.8" strokeLinecap="round" />
          <path d="M94 54c2 7 6 12 12 14" fill="none" stroke="rgba(255,255,255,0.55)" strokeWidth="2.8" strokeLinecap="round" />
          <path d="M30 83c7-1 12-4 16-10" fill="none" stroke="rgba(255,255,255,0.42)" strokeWidth="2.6" strokeLinecap="round" />
          <path d="M82 73c4 6 9 9 16 10" fill="none" stroke="rgba(255,255,255,0.42)" strokeWidth="2.6" strokeLinecap="round" />

          <circle cx="99" cy="28" r="5.5" fill="#6f8aa9" opacity="0.78" />
          <circle cx="29" cy="93" r="4.5" fill="#59bcae" opacity="0.76" />
          <circle cx="101" cy="84" r="3.8" fill="#7aa8c9" opacity="0.78" />
        </g>
      </svg>
    </div>
  );
}
